// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__32qxI","inner":"Form_inner__2l_yO","range":"Form_range__TEk8E","name":"Form_name__ydQqO","actions":"Form_actions__y51d5"};